export default __webpack_public_path__ + "static/media/gallery-wip-pommel_04.ea4e81b9.jpg";